<script lang="ts">
  import SupplierNavbarUserPopover from "./SupplierNavbarUserPopover.svelte";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";
  import Authorization from "@shared/svelte/Components/Authorization.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import * as _ from "lodash";
  // functions
  export let logout;

  export let trueUserDisplayName: string;
  export let accountDisplayName: string;
  export let trueUser;
  export let user;

  const links = [["./supplier", "landing"]];

  const openPreview = () => {
    HttpPromise({
      url: "/api/distributor/manufacturers/preview",
      method: "POST",
    }).then(res => {
      //@ts-ignore
      window.location = "/";
    });
  };
  const isActiveLink = path => {
    return window.location.pathname === path;
  };

  const navToDashboard = () => {
    //@ts-ignore
    window.location = "/supplier";
  };

  const navToInventory = () => {
    //@ts-ignore
    window.location = "/distributor/products";
  };

  let showProductSheets = _.get(user, "distributors[0].uses_sell_sheets");
</script>

<style>
  .white-bar {
    height: 24px;
    border-right: 1px solid white;
  }

  .preview:hover {
    text-decoration: underline;
    background: none;
  }
</style>

<div class="fizz-space-between">
  <!-- Left side -->
  <div class="fizz-flex-row">
    <!-- spacer -->
    <div class="fizz-inline-16" />
    <!-- logo -->
    <Icon
      type="ProviLogo"
      extraStyles="width: 100px; height: 40px;"
      extraClassNames="rep-confirm__logo fizz-icon-logo fizz-text-inverse"
    />
  </div>
  <!-- Right side -->
  <div class="fizz-flex-row fizz-inline-16">
    <Authorization authName={"product_lines.index"}>
      <div>
        <div class="capitalize cursor-pointer fizz-flex-row">
          <div class="fizz-text-small fizz-text-inverse underline-hover">
            <!-- svelte-ignore a11y-invalid-attribute -->
            <a
              href="javascript:void(0)"
              on:click={navToInventory}
              class:fizz-text-strong={isActiveLink("/distributor/products")}
              class="capitalize fizz-text-inverse cursor-pointer">Inventory</a
            >
          </div>
        </div>
      </div>
    </Authorization>

    <div>
      <div class="capitalize cursor-pointer fizz-flex-row">
        <div class="fizz-text-small fizz-text-inverse">
          <a
            href={"/supplier"}
            on:click={navToDashboard}
            class:fizz-text-strong={isActiveLink("/supplier")}
            class="capitalize fizz-text-inverse cursor-pointer">Dashboard</a
          >
        </div>
      </div>
    </div>

    {#if showProductSheets}
      <Authorization authName={"sell_sheets.index"}>
        <div>
          <div class="capitalize cursor-pointer fizz-flex-row">
            <div class="fizz-text-small fizz-text-inverse">
              <a
                href={"/supplier/product_sheets"}
                class:fizz-text-strong={isActiveLink("/supplier/product_sheets")}
                class="capitalize fizz-text-inverse cursor-pointer">Product Sheets</a
              >
            </div>
          </div>
        </div>
      </Authorization>
    {/if}

    <div>
      <div class="capitalize cursor-pointer fizz-flex-row">
        <div class="fizz-text-small fizz-text-inverse underline-hover" id="supplier-preview">
          <button
            on:click={() => openPreview()}
            class="preview capitalize fizz-text-inverse cursor-pointer"
          >
            Preview
          </button>
        </div>
        <div class="white-bar" />
      </div>
    </div>
    <div>
      <ul class="fizz-flex-row fizz-inline-16">
        <li>
          <SupplierNavbarUserPopover
            {trueUserDisplayName}
            {accountDisplayName}
            {trueUser}
            {user}
            {logout}
          />
        </li>
      </ul>
    </div>
  </div>
</div>
